import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import { MdApps, MdOutlineCategory, MdOutlinePostAdd } from "react-icons/md";
import { TbCategory, TbFolderCheck, TbUsers, TbUserStar } from "react-icons/tb";
import { AiFillBank, AiOutlineDatabase } from "react-icons/ai";
import { FaRegCreditCard, FaRegFile } from "react-icons/fa";
import { TiCloudStorageOutline } from "react-icons/ti";
// import { GrDocumentPerformance } from "react-icons/gr";
import { FaWpforms } from "react-icons/fa6";
import { GoProjectTemplate } from "react-icons/go";
import { BiCategory } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { IoCubeOutline, IoExtensionPuzzleOutline } from "react-icons/io5";

const Sidebar = ({ activeItem, setActiveItem }) => {
  const { app } = useParams()
  const [openGroup, setOpenGroup] = useState(false);

  const handleToggle = (id) => {
    setOpenGroup((prev) => (prev === id ? "" : id));
  };

  const MenuItem = ({ id, icon, label }) => (
    <div
      className={`sidebar-item ${activeItem === id ? "active" : ""}`}
      onClick={() => setActiveItem(id)}
    >
      {icon}
      <span>{label}</span>
    </div>
  );

  return (
    <aside className="sidebar-container">
      {!app &&
        <div className="sidebar-section">
          <MenuItem id="applications" icon={<MdApps />} label="Applications" />
        </div>
      }
      {/* ================= Blog Management ================= */}
      <div className="sidebar-section-title">{`Blog Management`}</div>
      <div className="sidebar-section">
        <MenuItem id="blogCategory" icon={<BiCategory />} label="Category" />
      </div>
      <div className="sidebar-section">
        <MenuItem id="blogSubCategory" icon={<MdOutlineCategory />} label="Sub-Category" />
      </div>
      <div className="sidebar-section">
        <MenuItem id="blogPost" icon={<MdOutlinePostAdd />} label="Blog Post" />
      </div>

      {app === "sitePilot" &&
        <>
          <div className="sidebar-section-title">{`Discovery Controls`}</div>
          <div className="sidebar-section">
            <MenuItem id="discoveryCategory" icon={<BiCategory />} label="Category" />
          </div>
          <div className="sidebar-section">
            <MenuItem id="discoverySubCategory" icon={<MdOutlineCategory />} label="Sub-Category" />
          </div>
          <div className="sidebar-section-title">{`Services`}</div>
          <div className="sidebar-section">
            <MenuItem id="sitePilotIntegrations" icon={<IoExtensionPuzzleOutline />} label="Integrations" />
          </div>
          <div className="sidebar-section">
            <MenuItem id="sitePilotAddons" icon={<IoCubeOutline />} label="Add-ons" />
          </div>
          <div className="sidebar-section-title">{`Mail Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="mailTemplates" icon={<GoProjectTemplate />} label="Mail Template" />
          </div>
          <div className="sidebar-section-title">{`Client Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="sitePilotClients" icon={<TbUsers />} label="Clients" />
          </div>
        </>
      }

      {app === "workBridge" &&
        <>
          <div className="sidebar-section-title">{`Work-Bridge Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="forms" icon={<FaWpforms />} label="Form Management" />
          </div>
        </>
      }

      {app === "vaults" &&
        <>
          <div className="sidebar-section-title">{`Vault Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="category" icon={<BiCategory />} label="Category" />
            <MenuItem id="formMeta" icon={<FaWpforms />} label="Form Metadata" />
          </div>
          <div className="sidebar-section">
            <div className={`section-header ${openGroup === "metadata" ? "open" : ""}`} onClick={() => handleToggle("metadata")}>
              <div className="hstack gap-2">
                <TbCategory />
                <span>Metadata</span>
              </div>
              {openGroup === "metadata" ? (
                <RiArrowDownSLine />
              ) : (
                <RiArrowRightSLine />
              )}
            </div>

            <Collapse in={openGroup === "metadata"}>
              <div className="section-body ms-3">
                <MenuItem id="fileMeta" icon={<FaRegFile />} label="File Metadata" />
                <MenuItem id="bankMeta" icon={<AiFillBank />} label="Bank Metadata" />
                <MenuItem id="cardMeta" icon={<FaRegCreditCard />} label="Card Metadata" />
                <MenuItem id="databaseMeta" icon={<AiOutlineDatabase />} label="Database Metadata" />
                <MenuItem id="storageMeta" icon={<TiCloudStorageOutline />} label="Storage Metadata" />
              </div>
            </Collapse>
          </div>
          <div className="sidebar-section-title">{`Client Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="vaultClients" icon={<TbUsers />} label="Clients" />
          </div>
        </>
      }

      {!app &&
        <>
          <div className="sidebar-section-title">{`User Management`}</div>
          <div className="sidebar-section">
            <MenuItem id="users" icon={<TbUsers />} label="Users" />
            <MenuItem id="designation" icon={<TbUserStar />} label="Designation" />
          </div>
        </>
      }

      {/* ================= SYSTEM MANAGEMENT ================= */}
      <div className="sidebar-section-title">{`System Management`}</div>
      <div className="sidebar-section">
        <MenuItem id="otherLibrary" icon={<TbFolderCheck />} label="Globle Library" />
      </div>
    </aside>
  );
};

export default Sidebar;
